import { ChangeDetectorRef, Component, ElementRef, EventEmitter, inject, Input, Output, ViewChild } from '@angular/core';
import { ExtractionState, RRFile, summariseObject } from '../user-rag.component';
import { DisclaimerTypes } from '../../../../../interfaces/disclaimertypes';
import { FormControl } from '@angular/forms';
import { UploadService } from '../../../../../service/upload.service';
import { AiService } from '../../../../../service/ai.service';
import { GenAiService } from '../../../../../service/gen-ai.service';
import { maxCharsForTextExtraction, maxFileSizeInBite } from '../../../../../../environments/environment';

@Component({
    selector: 'app-rag-file-upload',
    standalone: false,
    templateUrl: './rag-file-upload.component.html',
    styleUrl: './rag-file-upload.component.scss'
})
export class RagFileUploadComponent {
    // Injections
    @ViewChild('file') fileInput!: ElementRef<HTMLInputElement>;
    cd = inject(ChangeDetectorRef);
    uploadService = inject(UploadService);
    genService = inject(GenAiService);


    @Output() close = new EventEmitter<void>();
    @Output() usecontent = new EventEmitter<string>();
    @Input({ required: true }) extractedObject: string | undefined;


    // Objects
    fileList: RRFile[] = [];
    backupData: any;
    errorInFiles: boolean = false;
    control: FormControl = new FormControl()
    errorList: string[] = [];

    // Variables
    maxCharsForTextExtraction = maxCharsForTextExtraction;
    maxFileSizeInBite = maxFileSizeInBite;
    allowedTypes: any;
    loading: boolean = false;
    summary: boolean = false;
    textTotal: string = '';
    editResponse: boolean = false;
    protected disclaimerTypes = DisclaimerTypes;

    ngAfterViewInit(): void {
        this.fileInput.nativeElement.value = '';
    }

    cancelEditing() {
        this.extractedObject = JSON.parse(JSON.stringify(this.backupData));
        this.control.setValue(this.extractedObject);
        this.editResponse = false;
        this.cd.detectChanges();
    }
    saveEditing() {
        this.backupData = JSON.parse(JSON.stringify(this.control.value));
        this.extractedObject = this.control.value;
        this.extractedObject = JSON.parse(JSON.stringify(this.control.value));

        this.editResponse = false;
        this.cd.detectChanges();
    }
    openEditMode() {
        this.editResponse = true;
        // Duplicate data to backupData
        this.backupData = JSON.parse(JSON.stringify(this.extractedObject));
        this.control.setValue(JSON.parse(JSON.stringify(this.extractedObject)));
    }

    onDragOver(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
    }

    onDragLeave(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
    }

    onDrop(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        if (event.dataTransfer?.files && event.dataTransfer.files.length > 0) {
            this.convertFileToText(Array.from(event.dataTransfer.files));
        }
    }

    onFileSelected(event: Event) {
        const inputElement = event.target as HTMLInputElement;
        if (!inputElement.files || inputElement.files.length === 0) {
            return;
        }
        this.convertFileToText(Array.from(inputElement.files));
        inputElement.value = '';
    }

    async convertFileToText(files: RRFile[] | undefined): Promise<void> {
        if (!files || files.length === 0) return;
        const reader = new FileReader();
        this.extractedObject = undefined;
        this.errorInFiles = false;



        for await (let file of files) {
            this.fileList.push(file);
            // console.log(file.size, file.name);

            if (file.size > maxFileSizeInBite) {
                this.errorList.push(ExtractionState.ERROR_TO_BIG);
                this.errorInFiles = true;
                continue;
            }
            file.extractingState = ExtractionState.PENDING;
            let text;

            if (file.type.indexOf("pdf") !== -1) {
                let t = await this.uploadService.uploadPdfForTextExtract(file);
                if (t.pages) {
                    text = t.pages
                    file.extractingState = ExtractionState.SUCCESS;
                }
                else {
                    this.errorList.push(ExtractionState.ERROR);
                    this.errorInFiles = true;
                    continue;
                }
            } else if (file && file.type.indexOf("text") !== -1) {
                const reader = new FileReader();

                text = await new Promise((resolve) => {
                    reader.onload = (e: any) => {
                        const text = e.target.result;
                        file.extractingState = ExtractionState.SUCCESS;
                        resolve(text);
                    };
                    reader.onerror = (e: any) => {
                        console.log("Error", e);
                        this.errorList.push(ExtractionState.ERROR);
                        this.errorInFiles = true;
                        resolve('')
                    };
                    reader.readAsText(file);

                });
            } else {
                this.errorList.push(ExtractionState.ERROR_WRONG_TYPE);
                this.errorInFiles = true;
                continue;
            } 



            this.textTotal += `

      ${text}`;

        }

        if (this.textTotal.length > maxCharsForTextExtraction) {
            this.errorList.push(ExtractionState.ERROR_TOO_MUCH_TEXT);
            this.errorInFiles = true;

        }

        setTimeout(() => {
            this.errorList = []
        }, 5000);

        if (this.errorInFiles === true) {
            this.fileList = [];
            this.extractedObject = undefined;
        }
        this.cd.detectChanges();
        return;
    }

    async summerizeDocs() {
        // Text extraction and processing completed
        //  Send Text to LLM for summarize

        this.summary = true;
        this.loading = true;
        let result: any = await this.genService.cleanAiResponse("GEN_DocSummary", this.textTotal)
        // console.log("==== AI Summarize", result);
        this.loading = false;
        if (result === false) {
            // this.summaryState = 'Summary failed';
            return;
        }

        // console.log(result);

        if (result.result) {
            // this.summaryState = 'Summary successful';
            this.extractedObject = result.result;
            this.cd.detectChanges();
        } else {
            // this.summaryState = 'Summary failed';
        }
    }

    uploadNewDocument() {
        this.fileList = []
        this.extractedObject = undefined;
    }
    private sameFile(a: File, b: File): boolean {
        return a.name === b.name && a.size === b.size && a.lastModified === b.lastModified;
    }

    openFileNewTab(file: File) {
        window.open(URL.createObjectURL(file), '_blank');
    }
    deleteFile(file: File): void {
        // 1) Aus eigener Liste entfernen
        this.fileList = this.fileList.filter(f => !this.sameFile(f, file));
        this.extractedObject = undefined;

        // 2) FileInput aktualisieren (FileList neu aufbauen)
        const input = this.fileInput?.nativeElement as HTMLInputElement | undefined;
        if (!input?.files) return;

        const dt = new DataTransfer();
        for (const f of Array.from(input.files)) {
            if (!this.sameFile(f, file)) {
                dt.items.add(f);
            }
        }
        input.files = dt.files; // FileList ersetzen
    }
}
